import { styled } from '@linaria/react';
import { Spacings } from 'types/Theme';
import { cssTheme } from '@daedalus/atlas/themes';
const _exp2 = /*#__PURE__*/() => ({
  paddingTop = 's700'
}) => cssTheme.layout.spacing[paddingTop];
const _exp3 = /*#__PURE__*/() => ({
  paddingBottom = 's700'
}) => cssTheme.layout.spacing[paddingBottom];
export const WrapperWithPadding = /*#__PURE__*/styled('section')({
  name: "WrapperWithPadding",
  class: "wkx7fun",
  propsAsIs: false,
  vars: {
    "wkx7fun-0": [_exp2()],
    "wkx7fun-1": [_exp3()]
  }
});

require("./WrapperWithPadding.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./WrapperWithPadding.tsx");